(() => {
  const charts = {
    motorcycle: [[5,6.5,37,23.7,24.2],[5.5,7,38,24.4,24.9],[6.5,8,39,25.1,25.6],[7,8.5,40,25.7,26.2],[8,9.5,41,26.4,26.9],[8.5,10,42,27,27.5],[9.5,11,43,27.7,28.2],[10,11.5,44,28.4,28.9],[11,12.5,45,29.1,29.6],[12,13.5,46,29.7,30.2],[12.5,14,47,30.4,30.9],[13.5,15,48,31.1,31.6]],
    'cycling-road': [[5,6.5,37,23.5,24],[5.5,7,38,23.8,24.3],[6.5,8,39,24.8,25.3],[7,8.5,40,25.2,25.7],[8,9.5,41,26.2,26.7],[8.5,10,42,26.5,27],[9.5,11,43,27.5,28],[10,11.5,44,27.8,28.3],[11,12.5,45,28.8,29.3],[12,13.5,46,29.2,29.7],[12.5,14,47,30.2,30.7]],
    golf: [[4,5.5,36,22.3,23.3],[5,6.5,37,23,24],[5.5,7,38,23.7,24.7],[6.5,8,39,24.3,25.3],[7,8.5,40,25,26],[8,9.5,41,25.7,26.7],[8.5,10,42,26.3,27.3],[9.5,11,43,27,28],[10,11.5,44,27.7,28.7],[11,12.5,45,28.3,29.3],[12,13.5,46,29,30],[12.5,14,47,29.6,30.6]],
    baseball: [[6.5,8,39,25.2,25.7],[7,8.5,40,25.9,26.4],[8,9.5,41,26.5,27],[8.5,10,42,27.2,27.7],[9.5,11,43,27.9,28.4],[10,11.5,44,28.5,29.1],[11,12.5,45,29.3,29.8],[12,13.5,46,29.9,30.5]],
    weightlifting: [[6.5,8,39,24.8,25.3],[7,8.5,40,25.5,26],[8,9.5,41,26.1,26.6],[8.5,10,42,26.8,27.3],[9.5,11,43,27.5,28],[10,11.5,44,28.1,28.6],[11,12.5,45,28.8,29.3],[12,13.5,46,29.5,30]],
    climbing: [[null,null,32,18.1,18.6],[null,null,33,18.8,19.3],[null,null,34,19.5,20],[null,null,35,20.1,20.6],[4.5,5.5,36,20.8,21.3],[5,6.5,37,21.5,22],[5.5,7,38,22.1,22.6],[6.5,8,39,22.8,23.3],[7,8.5,40,23.5,24],[8,9.5,41,24.1,24.6],[8.5,10,42,24.8,25.3],[9.5,11,43,25.4,25.9],[10,11.5,44,26.1,26.6]],
    boxing: [[5.5,7,38,23.9,24.4],[6.5,8,39,24.5,25],[7,8.5,40,25.2,25.7],[8,9.5,41,25.8,26.3],[8.5,10,42,26.5,27],[9.5,11,43,27.1,27.6],[10,11.5,44,27.8,28.3],[11,12.5,45,28.5,29],[12,13.5,46,29.1,29.6],[12.5,14,47,30.2,30.7]]
  };
  const columns = { usMen: 0, usWomen: 1, eu: 2, cm: 3 };
  const match = (value, rows, gender) => {
    const raw = value.trim();
    const number = Number(raw.replace(/^(?:US\s*)?(?:EU\s*)?/i, ''));
    if (!Number.isFinite(number)) return null;
    if (/^US\s*/i.test(raw)) return rows.find(row => row[gender === 'women' ? 1 : 0] === number) || null;
    if (/^EU\s*/i.test(raw) || number >= 30) return rows.find(row => row[2] === number) || null;
    return null;
  };
  function init(picker) {
    picker.querySelectorAll('.aoraki-size-tools:not([data-size-ready])').forEach(tool => {
      const rows = charts[tool.dataset.sizeChart];
      const fieldset = tool.closest('fieldset');
      if (!rows || !fieldset) return;
      const options = [...fieldset.querySelectorAll('input[type="radio"]')].map(input => ({ input, label: fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`), row: match(input.value, rows, tool.dataset.sizeGender) }));
      if (!options.some(option => option.row)) { tool.hidden = true; return; }
      tool.dataset.sizeReady = 'true';
      const render = system => {
        for (const option of options) {
          if (!option.label) continue;
          const converted = option.row?.[columns[system]];
          option.label.textContent = converted == null ? option.input.value : String(converted);
          option.label.title = converted == null ? `Original size ${option.input.value}; no conversion` : `EU ${option.row[2]} · foot ${option.row[3]} cm · in-shoe ${option.row[4]} cm`;
        }
        tool.querySelectorAll('[data-size-system]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeSystem === system)));
        tool.dataset.activeSystem = system;
      };
      const preferred = 'eu';
      render(preferred);
      tool.querySelectorAll('[data-size-system]').forEach(button => button.addEventListener('click', () => render(button.dataset.sizeSystem)));
      const dialog = tool.querySelector('dialog');
      const tbody = dialog.querySelector('tbody');
      rows.forEach(row => {
        const tr = document.createElement('tr');
        row.forEach(value => { const td = document.createElement('td'); td.textContent = value == null ? 'N/A' : String(value); tr.append(td); });
        tbody.append(tr);
      });
      [...dialog.querySelectorAll('thead th')].forEach((th, index) => {
        if (!/^\s*(US|UK)\b/i.test(th.textContent || '')) return;
        th.style.display = 'none';
        tbody.querySelectorAll('tr').forEach(tr => { const td = tr.children[index]; if (td) td.style.display = 'none'; });
      });
      tool.querySelector('.aoraki-size-guide-open').addEventListener('click', () => dialog.showModal());
      tool.querySelector('.aoraki-size-dialog-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
  }
  const run = () => document.querySelectorAll('variant-selects').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();

